import React from 'react'
import PropTypes from 'prop-types'
import MUIIcon from '@material-ui/core/Icon'

const Icon = ({ className, children }) => <MUIIcon className={className}>{children}</MUIIcon>

export default Icon
